import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TwoColumns from 'components/layout/TwoColumns/index.js';
import messages from './messages.js';
import InviteHeading from './InviteHeading.jsx';

const InviteFrame = styled(TwoColumns)`
  & > * {
    text-align: center;
  }
`;

function Email(props) {
  const { children, ...rest } = props;
  return (
    <div {...rest}>
      <InviteHeading icon="ss-mail" title={messages.mailInvitations} />
      {children}
    </div>
  );
}

Email.propTypes = {
  children: PropTypes.node,
};

function Print(props) {
  const { children, ...rest } = props;
  return (
    <div {...rest}>
      <InviteHeading icon="ss-print" title={messages.printInvitations} />
      {children}
    </div>
  );
}

Print.propTypes = {
  children: PropTypes.node,
};

InviteFrame.Email = Email;
InviteFrame.Print = Print;

export default InviteFrame;
